<template>
  <base-layout>
    <template v-slot:header>
      <app-header />
    </template>
    <template v-slot:banner>
      <Banner :title="title" />
    </template>
    <template v-slot:default>
      <ContactForm />
    </template>

    <template v-slot:footer>
      <app-footer />
    </template>
  </base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import ContactForm from '@/components/ContactForm'
import Banner from '@/components/Breadcrumb'
import BaseLayout from '@/layout/BaseLayout'

export default {
  title: 'Frequently Asked Questions - SanitizerWristbands.com',
  components: {
    BaseLayout,
    AppHeader,
    ContactForm,
    Banner,
    AppFooter
  },
  data () {
    return {
      title: 'Contact Us'
    }
  },
  mounted () {
    window.analytics.page('Contact')
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/style.scss";
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue